export default {
    checked: null,
    user: null,
    newOrder: null,
    listState: [
        {
            id: 1,
            title: "Новые",

        },
        {
            id: 2,
            title: "Принятые",

        },
        {
            id: 3,
            title: "Отмененные",

        },
        {
            id: 4,
            title: "Выполненные",

        },
    ],
    /**Dynamic models of list for select */
    modals: {
        group: {
            modalCreate: "groups",
            fields: [
                {
                    label: "Название",
                    key: "name",
                    type: "text",
                },
                {
                    label: "Максимальная цена просмотра",
                    key: "max_price",
                    type: "numeric",
                },
                {
                    label: "Скидка (%) на товары",
                    key: "sale",
                    type: "numeric",
                },
            ],
            isAdd: true,
            isUpdate: false,
            searchDisable: true,
            removeLink: "admin/groups/delete",
            cardLink: "group",
            itemLink: "admin/groups",
            setLink: "admin/groups/create",
            columns: [

                {
                    key: "name",
                    radio: true,
                    title: "Наименование",
                    align: "left",
                },
                {
                    key: "sale",
                    title: "Скидка (%)",
                    checkbox: false,
                    control: false,
                    align: "left",
                    timer: false,
                },
                {
                    key: "max_price",
                    title: "Максимальная цена просмотра",
                    checkbox: false,
                    control: false,
                    align: "left",
                    timer: false,
                },
            ],
        }
    },
    modalName: null,
    valueSelected: null,
    lastUpdate: null
}